import React, { useState } from "react";
import { FaPlus, FaEdit, FaSignOutAlt, FaSave, FaTimes } from "react-icons/fa";
import "./BarraMenu.css";
import { ModoBarra } from "../utils";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Typography
} from "@mui/material";
import { CheckOutlined, CloseOutlined, InfoOutlined } from "@mui/icons-material";

const FaPlusIcon = FaPlus as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const FaEditIcon = FaEdit as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const FaSignOutAltIcon = FaSignOutAlt as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const FaSaveIcon = FaSave as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const FaTimesIcon = FaTimes as unknown as React.FC<React.SVGProps<SVGSVGElement>>;

interface BarraMenuProps {
  pTitulo?: string;
  modoAtual: ModoBarra;
  pEditavel?: boolean

  onAcao?: (acao: string) => void;
}

const BarraMenu: React.FC<BarraMenuProps> = ({ pTitulo, modoAtual = ModoBarra.leitura, onAcao, pEditavel }) => {
  //const [mode, setMode] = useState<ModoBarra>(modoInicial);
  const mode = modoAtual;

  const [confirmarCancelarAberto, setConfirmarCancelarAberto] = useState(false);

  const confirmarCancelamento = () => {
    setConfirmarCancelarAberto(false);
    onAcao?.("cancelar");
  };

  const continuarEdicao = () => {
    setConfirmarCancelarAberto(false);
  };

  const handleNew = () => {
    onAcao?.("novoregistro");
    //onAcao?.("novo");
  };

  const handleEdit = () => {
    //setMode(ModoBarra.edicaoregistro);
    //onAcao?.("editar");
    onAcao?.("edicaoregistro");
  };

  const handleCancel = () => {
    //setMode(ModoBarra.leitura);
    //onAcao?.("cancelar");
    setConfirmarCancelarAberto(true);
    //onAcao?.("cancelar");
  };

  const handleSave = () => {
    //setMode(ModoBarra.leitura);
    //onAcao?.("salvar");
    onAcao?.("salvar");

  };

  const handleExit = () => {
    onAcao?.("sair");
  };


  function MontaBotaoMenu(pOnClick: any, pLabel: string, pEditavel: boolean | null) {
    let Icon;

    switch (pLabel) {
      case "Novo": Icon = FaPlusIcon; break;
      case "Editar": Icon = FaEditIcon; break;
      case "Salvar": Icon = FaSaveIcon; break;
      case "Cancelar": Icon = FaTimesIcon; break;
      case "Sair": Icon = FaSignOutAltIcon; break;
      default: Icon = FaPlusIcon; // ícone padrão
    }

    const buttonStyle =
      pEditavel === false
        ? { backgroundColor: "#757575" }
        : pLabel === "Salvar"
          ? { backgroundColor: "#2f9e44" }
          : pLabel === "Cancelar"
            ? { backgroundColor: "#e03131" }
            : {};

    return (
      <button className="menu-button"
        onClick={pOnClick}
        disabled={pEditavel === false}
        style={buttonStyle}>
        <Icon className="menu-icon" />
        <span>{pLabel}</span>
      </button>
    );
  }

  const MontarBotoes = () => {
    let botoesEspecificos: JSX.Element | null = null;
    let botoesCancelarSalvar: JSX.Element = (
      <>
        {MontaBotaoMenu(handleSave, 'Salvar', null)}
        {MontaBotaoMenu(handleCancel, 'Cancelar', null)}
      </>
    );

    switch (modoAtual) {
      case ModoBarra.leitura: break;
      case ModoBarra.edicao: botoesEspecificos = MontaBotaoMenu(handleEdit, 'Editar', pEditavel!); break;
      case ModoBarra.insercao: botoesEspecificos = MontaBotaoMenu(handleNew, 'Novo', null); break;
      case ModoBarra.edicaoregistro: botoesEspecificos = botoesCancelarSalvar; break;
      case ModoBarra.novoregistro: botoesEspecificos = botoesCancelarSalvar; break;
      default: botoesEspecificos = null;
    }

    return (
      <>
        {botoesEspecificos}
        {(modoAtual !== ModoBarra.edicaoregistro && mode !== ModoBarra.novoregistro) && MontaBotaoMenu(handleExit, 'Sair', null)}
      </>
    );
  };

  return (
    <div className="menu">
      {pTitulo && <div className="menu-titulo">{pTitulo}</div>}

      <div className="menu-container">
        {MontarBotoes()}
      </div>
      <Dialog
        open={confirmarCancelarAberto}
        onClose={continuarEdicao}
        PaperProps={{
          sx: {
            borderRadius: 2,
            border: "1px solid #d9e5ee",
            boxShadow: "0 10px 30px rgba(47, 83, 116, 0.12)",
            width: { xs: 'calc(100% - 22px)', sm: 320 },
            maxWidth: 320,
            overflow: "hidden"
          }
        }}
      >
        <DialogTitle sx={{ p: 0 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.2,
              px: 2,
              py: 1.05,
              borderBottom: "1px solid #d9e5ee",
              backgroundColor: "#ffffff"
            }}
          >

            <InfoOutlined sx={{ fontSize: 25, color: '#0965c1' }} />

            <Box>
              <Typography sx={{ fontSize: 15, fontWeight: 500, color: "#0f3550", lineHeight: 1.5 }}>
                Cancelar
              </Typography>
            </Box>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ px: 2, pt: "14px !important", pb: 1.5 }}>
          <DialogContentText sx={{ color: "#334155", fontSize: 14, fontWeight: 500 }}>
            Todas as alteracoes serao perdidas.
          </DialogContentText>
        </DialogContent>

        <DialogActions sx={{ px: 2, py: 1.2, backgroundColor: "#f8fbff" }}>
          <Button className="button-dialog"
            onClick={continuarEdicao}
            variant="contained"
            startIcon={<CloseOutlined sx={{ fontSize: 16 }} />}
            sx={{
              textTransform: "none",
              fontWeight: 500,
              borderRadius: 1,
              px: 1,
              backgroundColor: "#0965c1",
              '&:hover': { backgroundColor: "#0753a0" },
            }}
          >
            Não
          </Button>
          <Button className="button-dialog"
            onClick={confirmarCancelamento}
            variant="contained"
            startIcon={<CheckOutlined sx={{ fontSize: 16 }} />}
            sx={{
              textTransform: "none",
              fontWeight: 500,
              borderRadius: 1,
              px: 1,
              backgroundColor: "#0965c1",
              '&:hover': { backgroundColor: "#0753a0" },
            }}
          >
            Sim
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default BarraMenu;
